import { Component, OnInit } from '@angular/core';
import { LicenseService, LicenseStatus } from '../../services/license.service';
@Component({
    selector: 'app-license-banner',
    templateUrl: './license-banner.component.html',
    styleUrls: ['./license-banner.component.css']
})
export class LicenseBannerComponent implements OnInit {
    status: LicenseStatus | null = null;
    closed = false;

    constructor(private licenseService: LicenseService) {}

    ngOnInit(): void {
        // this.licenseService.getLicenseStatus().subscribe({
        //     next: (res) => this.status = res,
        //     error: () => this.status = { status: 'missing', message: 'Erreur de licence.' }
        // });
        console.log('hejj')

        this.licenseService.status$.subscribe(status => {
			console.log(status)
            this.status = status;

            // Réaffiche la bannière si nouvelle alerte
            if (status?.status === 'expiring' || status?.status === 'expired' || status?.status === 'missing'){
                this.closed = false;
            }
        });


    }

    closeBanner(): void {
        this.closed = true;
    }
}
